import { useEffect, useState } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { Dispatch } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import {
    AuthenticationAction,
    AuthenticationReducer,
    UserDataContext,
    UserDataContextTypeInitiator
} from 'types/autentication'
import { RootReducerState, Message, MessageTypeInitiator } from 'types/global'
import AuthenticationActions from 'actions/Authentication'
import { ROUTES_NAMES } from 'constants/name.routes'
import { InputLabel } from 'components/InputLabel'
import ActionStatus from 'components/ActionStatus'
import { ChangeStatus } from 'components/ChangeStatus'
import { Subtitle } from 'components/Toggle/styles'
import {
    ActionButton,
    cancelButton,
    ContainerActionButtons,
    InputsContainer,
    Line,
    locatedErrorSyle,
    NewUserContainer,
    Ptitle,
    saveButton,
    SpanTop,
    Span,
    Div,
} from 'pages/Configurations/FormUser/styles'
import { ILocationWithSector, IUserWithLocation, User, UserAction, UserReducer, UserServiceNowList, userProfiles } from 'types/user'
import ServiceUser from 'services/User'
import LocationActions from 'actions/Location'
import {
    LocationAction,
    LocationReducer,

} from 'types/location'
import { SectorAction, SectorReducer, } from 'types/sector'
import SectorActions from 'actions/Sector'
import UserActions from 'actions/User'
import UserServices from 'services/User'
import { Label } from 'components/InputLabel/styles'
import { useMsal, useAccount } from '@azure/msal-react'
import { loginRequest } from 'authConfig'
import { userProfilesWithPermissionText } from 'utils/userProfiles'
import { UnitySectorTable } from './UnitySectorTable'
import { roleByLabel } from 'utils/getRoleByLabel'


export interface IFormLocation {
    id: string;
    unity: string;
    sector: string[];
}
/**
 * JSX com formulário usado para cadastrar/editar as informações de usuário
 * @returns 
 */
const FormUser = () => {
    const [message, setMessage] = useState<Message>(MessageTypeInitiator)
    let setMessageSuccess = (text: string) =>
        setMessage({ visible: true, status: 2, text: text } as Message)
    let setMessageError = (text: string) =>
        setMessage({ visible: true, status: 0, text: text } as Message)
    const { state: currentSelectedUser, pathname } = useLocation()
    const [currentSelectedUserState, setCurrentSelectedUserState] =
        useState(currentSelectedUser)
    const [actionStatus, setActionStatus] = useState<boolean>(false)
    const [focusedSectorOrUnity, setFocusedSectorOrUnit] = useState('')
    const currentStatus = currentSelectedUserState?.status === 'Ativo' ? 1 : 2
    const [userLocated, setUserLocated] = useState(false)
    const [userNotFound, setUserNotFound] = useState(false)
    const [userEmpty, setUserEmpty] = useState(false)
    const [formLocations, setFormLocations] = useState<IFormLocation[]>()


    const [currentUserStatus, setCurrentUserStatus] =
        useState<number>(currentStatus)
    const authenticationDispatch: Dispatch<AuthenticationAction> =
        useDispatch<Dispatch<AuthenticationAction>>()
    const sectorDispatch: Dispatch<SectorAction> =
        useDispatch<Dispatch<SectorAction>>()
    const userDispatch: Dispatch<UserAction> =
        useDispatch<Dispatch<UserAction>>()
    const locationDispatch: Dispatch<LocationAction> =
        useDispatch<Dispatch<LocationAction>>()
    const locationSelector: LocationReducer = useSelector(
        (state: RootReducerState) => state.locationReducers
    )
    const sectorSelector: SectorReducer = useSelector(
        (state: RootReducerState) => state.sectorReducers
    )
    const userSelector: UserReducer = useSelector(
        (state: RootReducerState) => state.userReducers
    )
    const { id } = useParams()
    const navigate = useNavigate()
    const {
        register,
        control,
        watch,
        handleSubmit,
        setValue,
        formState: { isValid, errors },
        setFocus,
        getValues
    } = useForm({})
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'fields'
    })

    const userValue: string = watch('user')
    const nameValue: string = watch('name')
    const emailValue: string = watch('email')
    const unityValue: string = watch('unity')
    const [profileValue, setProfileValue] = useState('')
    const sectorValue: string = watch('sector')
    const locateIsValid = userValue?.length > 3
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0])
    const [errorFields, setErrorFields] = useState([])

    useEffect(() => {
        append({
            id: uuidv4(),
        })
    }, [])

    /**
     * Obtendo instancia do Reducer através dos seletores de estado
     */
    const authenticationSelector: AuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )

    const handleNavigateToUsers = () => {
        navigate(ROUTES_NAMES.configurationsRoutes.configurations)
    }

    useEffect(() => {
        remove()
        append({
            id: uuidv4(),
        })
    }, [profileValue])
    /**
     * Evento para localizar o usuário via Microsoft Graph
     */
    const handleLocateUser = () => {
        instance.acquireTokenSilent({
            ...loginRequest,
            account,
        }).then((res: any) => {
            AuthenticationActions.getUserBySaAccountName(
                authenticationDispatch,
                userValue, res.accessToken
            )
        }).catch((res: any) => {
            AuthenticationActions.getUserBySaAccountName(
                authenticationDispatch,
                userValue, null
            )
        })
    }

    const handleSubmitNewUser = (data: any) => {
        if (pathname.includes(ROUTES_NAMES.configurationsRoutes.newUser)) {
            navigate('/configuracoes', { state: data })
        } else {
            setActionStatus(true)

            setTimeout(() => {
                setActionStatus(false)
            }, 3000)
        }
    }
    /**
     * Usado para limpar os valores do formulário e coloca admin como perfil padrão
     */

    /**
     * Obtém o objeto de GrahpData gravado noi Redux.
     * @returns 
     */
    let getGraphData = (): UserDataContext => {

        let userDataGraph: UserDataContext = UserDataContextTypeInitiator
        if (authenticationSelector?.dataGraph && authenticationSelector?.dataGraph.length) {
            userDataGraph = authenticationSelector?.dataGraph[0]
        }
        return userDataGraph
    }
    /**
     * Prenche informações para cadastrar ao carregar a página (usuário novo)
     */
    useEffect(() => {
        LocationActions.getAllLocations(locationDispatch)
        SectorActions.getAllSectorsGroupedByLocationsId(sectorDispatch)
        if (id) {
            UserActions.getUserByIdResource(userDispatch, id)
        }
    }, [id])


    /**
     * Prenche informações para editar ao carregar a página (usuário editar)
     */
    useEffect(() => {
        if (userSelector.user && id) {
            const user = userSelector.user
            // SectorActions.getAllSectorsByLocationId(sectorDispatch, userSelector.user.u_location.value)
            setValue(
                'user',
                user['u_user_email'].split('@')[0]
            )
            setValue('name', user['name'])
            setValue('email', user['u_user_email'])
            setProfileValue(roleByLabel[user['u_profile'] as any])
            setCurrentUserStatus(
                /^true$/i.test(user['u_active'] as any) ? 1 : 2
            )
            const locations = user['u_locations'] as unknown as ILocationWithSector[]
            const formLocations = locations?.map(location => {
                const sectorsList = location?.sectors?.map(sector => {
                    return sector.sys_id
                })
                return {
                    id: uuidv4(),
                    unity: location.sys_id,
                    sector: sectorsList
                }
            })
            setFormLocations(formLocations)
        }
    }, [userSelector.user])

    useEffect(() => {
        setValue('fields', formLocations)
    }, [formLocations])
    /**
     * Prenche informações relacionado ao usuário no ServiceNow, GraphAPI e Notifica User Table
     */
    useEffect(() => {
        if (!id) {
            setUserLocated(false)
            setUserNotFound(false)
            
            let { givenName, userPrincipalName, surname } = getGraphData()

            const userServiceNow = getValues("user")

            
            let getUserByEmail = async () => {
                return await UserServices.getUsersByAttributeAndValue('u_user.email', userPrincipalName)
            }
            let getSystemUser = async () => {
                return await UserServices.getSystemUser(userPrincipalName.split('@')[0])
            }

            if (userPrincipalName != null && userPrincipalName != "") {
                getSystemUser().then((res: any) => {
                    const existSNUser = res?.length > 0
                    if (existSNUser) {
                        getUserByEmail().then((userServiceNowList: UserServiceNowList[]) => {
                            if (userServiceNowList.length > 0) {
                                setUserLocated(true)
                            } else if (getUserName() === userPrincipalName.split('@')[0] || userValue === userPrincipalName.split('@')[0]) {
                                setValue('name', `${givenName} ${surname}`)
                                setValue('email', userPrincipalName)
                            }
                        })
                    } else {
                        if(userServiceNow){
                            setUserNotFound(true)
                        }
                        
                    }
                })
            }
        }

    }, [authenticationSelector?.dataGraph])
    /**
     * Apaga o usuário atual e retorna para aba de configurações
     */
    const backToList = () => {
        UserActions.clearCurrentUser(userDispatch)
        navigate('/configuracoes')
    }

    /**
     * Apaga o usuário atual e retorna para aba de configurações
     */
    const showUnityToProfiles = () => {
        return ['nsp', 'location_qa', 'unit_general_manager', 'location_manager']
    }


    /**
     * Apaga o usuário atual e retorna para aba de configurações
     */
    const showSectorToProfiles = () => {
        return ['location_manager']
    }

    const getLocationsToSubmit = () => {
        const locations = getValues('fields')
        const treatedLocations = locations && locations.length ? locations?.map(location => {
            const sectorsList = location?.sector?.map(sector => {
                return {
                    sys_id: sector
                }
            })
            return {
                sys_id: location.unity,
                sectors: sectorsList
            }
        }) : []
        return treatedLocations
    }
    /**
     * Evento principal para atualizar um usuário no backend ServiceNow
     * @param sys_id - Valor do sys_id deve ser usado para edição
     */
    const updateUser = (sys_id: string) => {
        if (isFormUserValid()) {
            const treatedLocations = getLocationsToSubmit()
            const targetUser: IUserWithLocation = {
                u_user: emailValue,
                u_profile: profileValue,
                u_locations: treatedLocations,
                u_active: currentUserStatus === 1 ? 'true' : 'false'
            }

            UserServices.updateUserBySysIdResource(targetUser, sys_id)
                .then((response: any) => {
                    setActionStatus(true)
                    setTimeout(() => {
                        setActionStatus(false)
                    }, 3000)
                    UserActions.clearCurrentUser(userDispatch)
                    navigate('/configuracoes/usuarios', { state: { saveUser: true, messageSuccess: "Usuário editado com sucesso!" } })
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    /**
     * Evento principal para gravar novo usuário no backend ServiceNow
     */
    const createNewUser = () => {

        if (isFormUserValid()) {
            const messageExistUser: string = `Ocorreu um erro, usuário já cadastrado.`

            let getUserByEmail = async () => {
                return await UserServices.getUsersByAttributeAndValue('u_user.email', emailValue)
            }
            getUserByEmail().then((userServiceNowList: UserServiceNowList[]) => {
                if (userServiceNowList.length > 0) {
                    setMessageError(messageExistUser)
                    return false
                } else {
                    const treatedLocations = getLocationsToSubmit()
                    ServiceUser.createNewUserWithMultiLocations({
                        u_user: emailValue,
                        u_profile: profileValue,
                        u_locations: treatedLocations
                    })
                        .then((response: any) => {
                            if (response.data?.error || response.data?.errorMessage) {
                                setMessageError(messageExistUser)
                                window.scrollTo(0, 0)
                            } else {

                                setActionStatus(true)
                                setTimeout(() => {
                                    setActionStatus(false)
                                }, 3000)
                                navigate('/configuracoes/usuarios', { state: { saveUser: true, messageSuccess: "Novo usuário cadastrado com sucesso!" } })
                            }
                        })
                        .catch((error) => {
                            setMessageError(messageExistUser)
                            window.scrollTo(0, 0)
                            console.log(error)
                        })
                }
            })
        }
    }
    /**
     * Verifica se todo formulário foi prenchido corretamente antes de fazer a submissão de dados.
     * @returns true|false
     */
    const isFormUserValid = () => {
        if (userValue === '') {
            setUserEmpty(true)
            setFocus('user')
            return false
        }
        if (nameValue === '') {
            setFocus('name')
            setErrorFields(['name'])
            return false
        }
        if (emailValue === '') {
            setFocus('email')
            setErrorFields(['email'])
            return false
        }

        return true

    }
    /**
     * Muda o valor do perfil de acordo com o checkbox selecionado
     * @param event
     */
    const handleChangeProfileValue = event => {
        setProfileValue(event.target.value)
        setValue('unity', '')
        setValue('sector', '')
    }
    /**
     * Extrai nome de usuário do Azure usando dado armazenado no Redux
     * @returns 
     */
    const getUserName = () => {
        return authenticationSelector?.dataGraph
            && authenticationSelector?.dataGraph.length > 0 ?
            authenticationSelector?.dataGraph[0].mail.split('@')[0]
            : userValue
    }
    /**
     * Usado para gerenciar as mensagen de status do campo Localizar Usuário
     * @returns
     */
    const getMessageFieldUser = () => {
        let msg = ''
        if (userEmpty) {
            msg = 'Campo usuário é obrigatório'
        } else if (userLocated) {
            msg = 'Desculpe, usuário já cadastrado. Por favor, verifique e tente novamente.'
        } else if (userNotFound) {
            msg = 'Usuário não encontrado na listagem do ServiceNow. Por favor, contacte o suporte.'
        }
        return msg
    }

    const profileShouldHaveUnity = () => {
        return profileValue !== '' && showUnityToProfiles().includes(profileValue)
    }
    const profileShouldHaveSector = () => {
        return profileValue !== '' && showSectorToProfiles().includes(profileValue)
    }
    return (
        <NewUserContainer onSubmit={handleSubmit(handleSubmitNewUser)}>
            <SpanTop>
                <Span
                    className="cursor-pointer"
                    onClick={handleNavigateToUsers}
                >
                    Usuários
                </Span>
                <Span className="text-sm">{'>'}</Span>
                <Span className="font-semibold">
                    {pathname.includes(
                        ROUTES_NAMES.configurationsRoutes.newUser
                    )
                        ? 'Criar Usuário'
                        : 'Acessar usuário'}
                </Span>
            </SpanTop>

            <Ptitle>
                {pathname.includes(ROUTES_NAMES.configurationsRoutes.newUser)
                    ? 'Cadastrar novo usuário'
                    : 'Editar usuário'}
            </Ptitle>
            <Subtitle>
                {pathname.includes(ROUTES_NAMES.configurationsRoutes.newUser)
                    ? ' Preencha os dados abaixo para cadastrar um novo usuário.'
                    : 'Confira abaixo os dados do usuário cadastrado.'}
            </Subtitle>

            <InputsContainer>
                {message.visible && (
                    <ActionStatus text={message.text} status={message.status} />
                )}

                <Div className="flex gap-6">
                    <InputLabel
                        defaultValue={getUserName()}
                        className={getMessageFieldUser() != '' ? locatedErrorSyle : ''}
                        onBlur={() => {
                            setUserLocated(false)
                            setUserNotFound(false)
                            setUserEmpty(false)
                        }}
                        required={true}
                        maxLength={55}
                        inputWidth="w-[360px]"
                        label="Usuário"
                        name="user"
                        register={register}
                        readOnly={pathname.includes('edicao-usuario')}
                        toLocate={true}
                        error={{
                            message: getMessageFieldUser()
                        }}
                        buttonToLocate={{
                            disabled:
                                pathname.includes('edicao-usuario') ||
                                !locateIsValid,
                            styles:
                                pathname.includes(
                                    ROUTES_NAMES.configurationsRoutes.newUser
                                ) && locateIsValid
                                    ? 'bg-blueTheme'
                                    : '',
                            onClick: handleLocateUser
                        }}
                    />

                    {pathname.includes('edicao-usuario') && (
                        <>
                            <Line />
                            <ChangeStatus
                                setCurrentChangeStatus={setCurrentUserStatus}
                                currentChangeStatus={currentUserStatus}
                            />
                        </>
                    )}
                </Div>

                <InputLabel
                    defaultValue={currentSelectedUserState?.name}
                    inputWidth="w-[737px]"
                    label="Nome"
                    name="name"
                    required={true}
                    register={register}
                    className={errorFields.includes("name") ? locatedErrorSyle : "bg-lightGray50"}
                    onBlur={() => {
                        setErrorFields([])
                    }}
                    error={{
                        message: errorFields.includes("name") ? 'Campo nome é obrigatório' : ''
                    }}
                    readOnly
                />

                <InputLabel
                    defaultValue={currentSelectedUserState?.email}
                    inputWidth="w-[737px]"
                    label="E-mail"
                    name="email"
                    required={true}
                    register={register}
                    className={errorFields.includes("email") ? locatedErrorSyle : "bg-lightGray50"}
                    onBlur={() => {
                        setErrorFields([])
                    }}
                    error={{
                        message: errorFields.includes("email") ? 'Campo email é obrigatório' : ''
                    }}
                    readOnly
                />

                <Div>
                    <Label>Perfil de Usuário</Label>
                    <div className="space-y-1">

                        {userProfilesWithPermissionText?.map((item) => (
                            <div key={item.id} className='flex items-center'>
                                <input name="perfil" id={item.id} type="radio"
                                    checked={item.id === profileValue}
                                    onChange={handleChangeProfileValue}
                                    className="h-[16px] w-[16px] border-gray-300 text-yellow focus:ring-0 focus:ring-offset-0" value={item.id} />
                                <label htmlFor={item.id} className='flex'>
                                    <span className="ml-2 block text-[14px] text-darkGray font-bold">{item.title}</span>
                                    <span className='text-sm'>&#160;- {item.permissionText}</span>
                                </label>
                            </div>
                        ))}

                    </div>
                </Div>
            </InputsContainer>
            <UnitySectorTable
                formLocations={formLocations}
                watch={watch}
                getValues={getValues}
                remove={remove}
                append={append}
                control={control}
                profileShouldHaveUnity={profileShouldHaveUnity}
                profileShouldHaveSector={profileShouldHaveSector}
                fields={fields}
                setFocusedSectorOrUnit={setFocusedSectorOrUnit}
                focusedSectorOrUnity={focusedSectorOrUnity}
                errorFields={errorFields}
                currentSelectedUserState={currentSelectedUserState}
                locationSelector={locationSelector}
                setValue={setValue}
                sectorSelector={sectorSelector}
            />
            <ContainerActionButtons>
                <ActionButton
                    onClick={() => backToList()}
                    className={cancelButton}
                >
                    Cancelar
                </ActionButton>

                <ActionButton
                    disabled={!isValid}
                    data-testid={`saveuserbutton`}
                    type={'button'}
                    className={`${saveButton} ${!isValid ? 'bg-disabled border-[#4F4F4F] hover:brightness-100 opacity-90 text-[#4F4F4F]' : ''}`}
                    onClick={() =>
                        !id
                            ? createNewUser()
                            : updateUser(userSelector.user.sys_id as any)
                    }
                >
                    Salvar
                </ActionButton>
            </ContainerActionButtons>
        </NewUserContainer>
    )
}

export { FormUser }

